// Canonical export-format identifiers for the Tenant Portal ledger
// Download control (LedgerDownloadDropdown). Kept in a dedicated module so
// the dropdown options and every consumer share a single source of truth
// for the selectable formats.
//
// The actual file generation lives in `ledger-export.js` (`exportLedger`)
// and is reached through the dropdown's `onSelect` callback, which
// `LedgerTabnav` wires to the export pipeline.

export const LEDGER_DOWNLOAD_FORMATS = Object.freeze({
  PDF: 'pdf',
  CSV: 'csv',
})
